module.exports = __webpack_public_path__ + "aboutHeaderBg.aaaeb7a6d08677414a5b.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/assets/img/aboutHeaderBg.jpg
// module id = ../../../../../src/assets/img/aboutHeaderBg.jpg
// module chunks = main